import { render, staticRenderFns } from "./MemoryDetails.vue?vue&type=template&id=3411e8ec&scoped=true"
import script from "./MemoryDetails.vue?vue&type=script&lang=js"
export * from "./MemoryDetails.vue?vue&type=script&lang=js"
import style0 from "./MemoryDetails.vue?vue&type=style&index=0&id=3411e8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3411e8ec",
  null
  
)

export default component.exports